<template>
  <div class="outterBox">
    <div class="topHeader">
      <span> 운영가능 코스 </span>
    </div>
    <div class="top">
      <b-tabs class="h-100 d-flex flex-column" v-if="courseList.length > 0" v-model="selectedCourseIndex">
        <b-tab :title="course.coseName" active v-for="course in courseList" :key="course.coseName">
          <div class="innerBox">
            <b-table-simple
              head-variant="light"
              sticky-header="490px"
              responsive
              fixed
              v-if="courseListItem.length > 0"
              class="text-center"
            >
              <b-thead>
                <b-tr>
                  <b-th class="col-lg-1 col-1" scope="col">코스</b-th>
                  <b-th class="col-lg-1 col-1" scope="col">홀 수</b-th>
                  <b-th class="col-lg-1 col-1" scope="col">시간</b-th>
                  <b-th class="col-lg-1 col-1" scope="col">변경</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(o, i) in courseListItem[selectedCourseIndex]" :key="i">
                  <b-td>{{ o.coseName }}</b-td>
                  <b-td>{{ o.rndCode }}</b-td>
                  <b-td>{{ o.time | toTime }}</b-td>
                  <b-td>
                    <button
                      v-if="!disable(o) && disable2(o)"
                      class="addButton"
                      @click="addItem(o, i)"
                      :disabled="disable(o)"
                    >
                      <span>추가</span>
                    </button>
                    <button
                      v-if="disable(o) && !disable2(o)"
                      class="deleteButton"
                      @click="removeItem(o, i)"
                      :disabled="disable2(o)"
                    >
                      <span>삭제</span>
                    </button>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <div v-else class="noItem">
              <span>등록된 접수가 없습니다.</span>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import reserveService from '@/services/rev.service';
import {ReceiptViewModel} from '@/pages/RevReceiptPage/Model/receiptModel';

export default {
  name: 'RealTeeOffPicker',
  props: {
    listType: String,
    revConfirmList: Array,
  },
  data() {
    return {
      selectedDate: null,
      selectedCourseIndex: -1,
      courseList: [],
      courseListItem: [],
      limitCount: 0,
      reservCount: 0,
    };
  },
  filters: {
    toTime: function (a) {
      if (!a) return '';
      let position = 2;
      var output = [a.slice(0, position), ':', a.slice(position)].join('');
      return output;
    },
  },
  watch: {
    selectedDate(newVal, oldVal) {
      this.refreshReserveCount();
    },
    selectedCourseIndex(o, n) {
      // console.log(this.selectedCourseIndex);
    },
  },
  async created() {
    await this.refreshReserveCount();
    this.$EventBus.$on('RevDateChanged', this.revDateChanged);
  },
  beforeDestroy() {
    this.$EventBus.$off('RevDateChanged', this.revDateChanged);
  },
  methods: {
    isCompany(o) {
      let user = this.$store.getters['Auth/selectedMember'];
      console.log('user', user, o);

      // 법인회원 코드 : 006
      return user.memType === '006';
    },
    getCourseHoleString(course) {
      if (course.coseCd === '001') {
        return '9';
      } else if (course.coseCd === '002') {
        return '18';
      } else {
        return '';
      }
    },
    async revDateChanged(date) {
      this.selectedDate = date;

      this.courseList = [];
      this.courseListItem = [];

      let courseList = await reserveService.getDateCourseList(this.listType, date);
      this.courseList = courseList.items;
      this.courseList.unshift({
        coseCd: '',
        coseItem: '',
        coseName: '모든코스',
      });
      // console.log('courseList', this.courseList);

      let selectedMember = this.$store.getters['Auth/selectedMember'];

      let totalArr = [];
      for (const x of this.courseList) {
        // console.log('reqResult.items', x);
        const reqResult = await reserveService.getGolfDateTeeList(this.selectedDate, x.coseCd, selectedMember.memNo);
        this.courseListItem.push(reqResult.items);
        totalArr.push(...reqResult.items);
      }
      this.courseListItem.unshift(totalArr);
      // console.log('courseListItem', this.courseListItem);

      this.selectedCourseIndex = 0;
    },

    async revCourseChanged(data) {
      this.selectedTeeOffList = [];
      let selectedMember = this.$store.getters['Auth/selectedMember'];

      // SET PARAM to DATA
      this.selectedDate = data.selectedDate;
      this.selectedCourse = data.selectedCourse;
      this.totalCourse = data.totalCourse;

      if (this.selectedCourse && this.selectedCourse.coseCd) {
        // 코스 선택값이 있을 경우
        // 사전 접수, 대기 접수 의 경우 첫 번째 Element 를 보내줌
        const reqResult = await reserveService.getGolfDateTeeList(
          this.selectedDate,
          this.selectedCourse.coseCd,
          selectedMember.memNo,
        );
        this.teeOffList = reqResult.items;
        this.checkExistSelection();
      } else {
        this.showDialog(`해당 날짜에 조회된 코스 정보가 없습니다.`);
      }
    },
    async refreshReserveCount() {
      let user = this.$store.getters['Auth/selectedMember'];
      const reqResult = await reserveService.getRevCountCheck(this.listType, this.selectedDate, user.memNo);
      this.limitCount = reqResult.obj.limitCount;
      this.reservCount = reqResult.obj.reservCount;
    },

    addItem(o, i) {
      let selectedCourse = this.courseList[this.selectedCourseIndex];
      let selectedTeeOff = this.courseListItem[this.selectedCourseIndex][i];
      // console.log(this.selectedDate, selectedCourse, selectedTeeOff);
      let model = this.makeReceiptConfirmModel(selectedCourse, selectedTeeOff);
      // console.log('===>');
      this.$EventBus.$emit('AddReceipt', model);
    },

    removeItem(o, i) {
      let selectedCourse = this.courseList[this.selectedCourseIndex];
      let selectedTeeOff = this.courseListItem[this.selectedCourseIndex][i];
      // console.log(this.selectedDate, selectedCourse, selectedTeeOff);
      let model = this.makeReceiptConfirmModel(selectedCourse, selectedTeeOff);
      this.$EventBus.$emit('RemoveReceipt', model);
    },

    makeReceiptConfirmModel(selectedCourse, selectedTeeOff) {
      // 실시간 예약 모델 생성
      let data = new ReceiptViewModel();
      data.selectedDate = this.selectedDate;
      data.selectedCourse = selectedCourse;
      data.selectedRealTeeOff = selectedTeeOff;
      data.teamCount = 1;
      data.teamLimitCount = this.limitCount;
      data.teamReservCount = this.reservCount;

      // 사용자 정보 추가
      // 사전 접수의 경우 > 회원권 번호-> 예약자 번호, 예약자명 -> 회원권 이름
      let loginUser = this.$store.getters['Auth/loginUser'];
      let selectedMember = this.$store.getters['Auth/selectedMember'];

      data.receiptDetail.bookName = loginUser.guestName;
      data.receiptDetail.memNo = selectedMember.memNo;
      data.receiptDetail.hpNo = loginUser.hpNo;

      // console.log(loginUser, selectedMember, data.receiptDetail);

      return data;
    },

    disable2(teeOffData) {
      let targetIndex = this.revConfirmList.findIndex(x => {
        if (x.CompareWithDate(this.selectedDate)) {
          let flag1 = x.selectedRealTeeOff.time === teeOffData.time;
          let flag2 = x.selectedRealTeeOff.rndCd === teeOffData.rndCd;
          let flag3 = x.selectedRealTeeOff.rndCode === teeOffData.rndCode;
          // console.log('disable', flag1, flag2, flag3, x.selectedRealTeeOff, teeOffData);
          return flag1 && flag2 && flag3;
        } else {
          return false;
        }
      });

      // console.log('targetIndex', targetIndex);
      if (targetIndex > -1) {
        return false;
      } else {
        return true;
      }
    },

    disable(teeOffData) {
      // COUNT 체크
      // console.log('teeOffData', teeOffData, this.limitCount, this.reservCount);
      // console.log('availableCount', this.getAvailableCount());

      let targetIndex = this.revConfirmList.findIndex(x => {
        if (x.CompareWithDate(this.selectedDate)) {
          let flag1 = x.selectedRealTeeOff.time === teeOffData.time;
          let flag2 = x.selectedRealTeeOff.rndCd === teeOffData.rndCd;
          let flag3 = x.selectedRealTeeOff.rndCode === teeOffData.rndCode;
          // console.log('disable', flag1, flag2, flag3, x.selectedRealTeeOff, teeOffData);
          return flag1 && flag2 && flag3;
        } else {
          return false;
        }
      });

      // console.log('targetIndex', targetIndex);
      if (targetIndex > -1) {
        return true;
      } else {
        return this.getAvailableCount() + this.reservCount >= this.limitCount;
      }
    },

    getAvailableCount() {
      let teamCount = 0;
      this.revConfirmList.forEach(x => {
        if (x.CompareWithDate(this.selectedDate)) {
          teamCount += x.teamCount;
        }
      });
      return teamCount;
    },
  },
};
</script>

<style scoped lang="scss">
.outterBox {
  border: 0px solid #6e6e6e;
}

.topHeader {
  padding-top: 1rem;
  padding-left: 2rem;
  font-weight: bold;
  font-size: 1.3rem;
}

.top {
  padding: 1.2rem 1.2rem;
}

.innerBox {
  border: 1px solid #eeeeee;
  background-color: white;
}

.b-table-sticky-header,
.table-responsive,
[class*='table-responsive-'] {
  margin-bottom: 0rem !important;
}

.deleteButton {
  display: inline-flex;
  align-items: center;
  height: 2.3rem;
  font-size: 0.8rem;
  width: 50%;
  background-color: #af8c5e !important;
  padding: 0px !important;
  color: white;
  border: none;
  outline: none;
  span {
    padding: 0px;
    width: 100%;
    text-align: center;
    padding: 0px !important;
  }
  &:hover {
    background-color: #af8c5e !important;
    color: white;
  }
}

.addButton {
  display: inline-flex;
  align-items: center;
  height: 2.3rem;
  font-size: 0.8rem;
  width: 50%;
  background-color: #af8c5e !important;
  padding: 0px !important;
  color: white;
  border: none;
  outline: none;

  span {
    padding: 0px;
    width: 100%;
    text-align: center;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  &:hover {
    background-color: #af8c5e !important;
    color: white;
  }
}
</style>
